import React, {MutableRefObject, PointerEvent} from "react"

export type TGUIPropper<T extends React.ElementType> = React.ComponentPropsWithoutRef<T>|((...args:any[]) => React.ComponentPropsWithoutRef<T>)

export interface IGUIProps {
    className?:string
}

export default class GUI {
    static proxy(ref:MutableRefObject<any>, extend:any){
        return new Proxy({}, {
            get(target,prop) {
                if (prop in extend) return extend[prop]
                const value = (ref.current as any)?.[prop]
                if (typeof(value)==="function") return value.bind(ref.current)
                else return value
            }
        }) as any        
    }
    static joinClass(...args:any[]) {
        const c : string[] = []
        for(const a of args){
            if (!a) continue
            else if (typeof(a)=="string") c.push(a)
            else if (a instanceof Array) c.push(...this.joinClass(...a))
            else if (a instanceof Object){
                if (a.className) c.push(a.className)
                else {
                    for(const k in a){
                        if (a[k]) c.push(k)
                    }
                }
            }
        }
        return c.join(" ")
    }
    static tick() {
        return new Promise(cb => requestAnimationFrame(cb))
    }
    static sleep(msec:number) : Promise<void> {
        return new Promise(cb => setTimeout(cb, msec))
    }
    static transitionEnd(dom:HTMLDivElement, signal?:AbortSignal, timeout?:number) : Promise<any> {
        const p:Promise<any>[] = [new Promise(cb => {
            const handler = () => {
                dom.removeEventListener("transitionend", handler)
                cb(true)
            }
            dom.addEventListener("transitionend", handler)
        })]
        if (signal) p.push(new Promise((_,fail) => signal?.addEventListener("abort", fail)))
        if (timeout) p.push(this.sleep(timeout))
        return Promise.race(p)
    }
    static dispatchEventAt(e:PointerEvent<HTMLElement>) {
        const target = document.elementFromPoint(e.clientX, e.clientY)
        if (target) {
            const clone = new (e.nativeEvent.constructor as any)(e.nativeEvent.type, e)
            target.dispatchEvent(clone)
        }
        return target
    }
    static isHTMLElement(e:Element) : e is HTMLElement {
        return "style" in e
    }
    static getProps<T extends React.ElementType>(propper?:TGUIPropper<T>, ...args:any[]) : React.ComponentPropsWithoutRef<T> {
        if (!propper) return {} as any
        else if (propper instanceof Function) return propper(...args)
        else return propper
    }
}